<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{checkModuleIndex('TNMTSR', 'R', constAccessType.view, '', -1)}} {{this.getLanguage['SMB']['TNMTSR']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4 && !hideBrand">
                                <span class='searchLabel'>{{this.getLanguage["GL"]["AGT"]}} :</span>
                                <customtreeselect :multiple="true"
                                                  :limit="1"
                                                  valueConsistsOf="LEAF_PRIORITY"
                                                  :disable-branch-nodes="false"
                                                  :limitText="count => `+${count}`"
                                                  :options="dd_agentgroup"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SAGT']}} :</span>
                                <div class="inline">
                                    <div class="d-flex">
                                        <input type="checkbox" v-model="IsGroupBySubAgent" id="IsGroupBySubAgent" :disabled="disableSubDD" />
                                        <label class="searchLabel ml-1" for="IsGroupBySubAgent">{{this.getLanguage["EVTSTL"]["GBSA"]}}</label>
                                    </div>
                                </div>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :cacheOptions="false"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :noResultsText="this.getLanguage['GL']['NRF']"
                                            :options="dd_subagentgroup"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="arr_FV['SAGAGI']"
                                            :disabled="disableSubDD"
                                            @input="SubAgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TNMT"]["PYT"]}} {{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['PTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['PTS'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['PTS'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["TNMT"]["PYT"]}} {{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_FV['PTS']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_FV['PTS'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_FV['PTS'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MSA"]["ET"]}} :</span>
                                <treeselect :multiple="false"
                                            :clearable="false"
                                            :options="dd_event_type"
                                            @input="EventTypeChange"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MSA.ET')"
                                            v-model="arr_FV['ET']" />
                            </div>
                            <div class='searchCol' v-if="arr_FV.ET==1 || arr_FV.ET==2">
                                <span class='searchLabel'>{{this.getLanguage['TNMT']['TTY']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_TournamentPayoutOption"
                                            :placeholder="getLanguage['GL']['ALL']"
                                            :max-height="200"
                                            @input="OganizerChange"
                                            v-model="arr_FV['CDT']"
                                            ref="CDT" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['TNMT']['TN']}} :</span>
                                <CInput size="sm" v-model="arr_FV['TN']" @change="OganizerChange"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currencyfilter"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CI']"
                                            @input="OganizerChange"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MEM"]["CTCI"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_currency"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('MEM.CI')"
                                            v-model="arr_FV['CTCI']"
                                            @input="updateCC()" />
                            </div>
                            <div class='searchCol' v-if="arr_FV.ET==3 || arr_FV.ET==4">
                                <span class='searchLabel'>{{this.getLanguage["AG"]["GP"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_gameProvider"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('AG.GP')"
                                            v-model="arr_FV['GPI']"
                                            ref="GPI" />
                            </div>
                            <div class='searchCol' v-if="arr_FV.ET==5">
                                <span class='searchLabel'>{{this.getLanguage["BETRPT"]["GP"]}} :</span>
                                <treeselect :multiple="true"
                                            :options="ddGameProviderList"
                                            :defaultExpandLevel="1"
                                            valueConsistsOf="LEAF_PRIORITY"
                                            @input="selectGameProvider"
                                            :placeholder="this.utilGetDDLanguage('BETRPT.GP')"
                                            v-model="searchGameProviderId"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            class="gp-dropdown" />
                            </div>
                            <div class='searchCol' v-if="arr_FV.ET==4 || arr_FV.ET==5">
                                <span class='searchLabel'>{{this.getLanguage["EVTSTL"]["IS"]}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_sponsor"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="getLanguage['GL']['ALL']"
                                            v-model="arr_FV['ISS']"
                                            ref="ISS" />
                            </div>
                            <div class='searchCol' v-if="arr_FV.ET==1 || arr_FV.ET==2">
                                <span class='searchLabel'>{{this.getLanguage['TNMT']['ORGN']}} :</span>
                                <treeselect :multiple="false"
                                            :cacheOptions="false"
                                            :load-options="loadOrganizerOptions"
                                            :options="ddOrganizerList"
                                            :auto-load-root-options="false"
                                            :disable-branch-nodes="true"
                                            :placeholder="this.utilGetDDLanguage('TNMT.ORGN')"
                                            v-model="arr_FV['OBAGI']" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" class='searchBtn' ref="search" size="sm" block color="success" @click="newSearch()">
                                <span class='searchIcon cil-search'></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-summarywrapper' v-if="arr_FV.ET!=5">
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead>
                            <!-- Prize Drop -->
                            <tr v-if="arr_FV.ET==2">
                                <th colspan="100%">{{this.getLanguage['MSA']['MRS']}}</th>
                            </tr>
                            <!-- Daily Lucky Spin -->
                            <tr v-else-if="arr_FV.ET==3">
                                <th colspan="100%">{{this.getLanguage['MTA']['DRSL']}}</th>
                            </tr>
                            <!-- Promotion Free Spin -->
                            <tr v-else-if="arr_FV.ET==4">
                                <th colspan="100%">{{this.getLanguage['MTA']['PRS']}}</th>
                            </tr>
                            <!-- One time Special Bonus -->
                            <tr v-else-if="arr_FV.ET==5">
                                <th colspan="100%">{{this.getLanguage['TNMTESR']['PBAS']}}</th>
                            </tr>
                            <!-- Tournament -->
                            <tr v-else>
                                <th colspan="100%">{{this.getLanguage['TNMT']['TNMTRS']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="arry_Psl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if="arry_Psl.length != 0" class='kema-eft'>
                            <td style="width:20%"></td>
                            <td style="width:20%"></td>
                            <td style="width:20%"></td>
                            <td style="width:20%">{{this.getLanguage['MTA']['GT']}}</td>
                            <td style="width:20%" :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(decimal_gt, 2, currencySymbol_gt) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!--Promotion Free Spin Summary-->
            <div class='table-summarywrapper'>
                <div class="custom-table-wrapper">
                    <table class='custom-table custom-tableMP afb-blue'>
                        <thead v-if="bool_showSummary">
                            <tr v-if="arr_FV.ET==4 || arr_FV.ET==5">
                                <th style="width:14%" v-if="arr_FV.ET==4">{{this.getLanguage['MTA']['C']}}</th>
                                <th style="width:14%" class="tableCtnRight" v-if="arr_FV.ET==4">{{this.getLanguage['MTA']['TMC']}}</th>
                                <th style="width:14%" class="tableCtnRight" v-if="arr_FV.ET==4">{{this.getLanguage['MTA']['TPC']}}</th>
                                <th style="width:14%" class="tableCtnRight" v-if="arr_FV.ET==4">{{ this.getLanguage["DLSP"]["NOS"] }}</th>
                                <th style="width:14%" class="tableCtnRight" v-if="arr_FV.ET==4">{{ this.getLanguage["DLSP"]["SW"] }}</th>
                                <th style="width:16%" class="tableCtnRight" v-if="arr_FV.ET==4">{{this.getLanguage['MTA']['FTA']}}</th>
                                <th style="width:50%" class="tableCtnRight" v-if="arr_FV.ET==5"></th>
                                <th style="width:10%" class="tableCtnRight" v-if="arr_FV.ET==5">{{this.getLanguage['MTA']['C']}}</th>
                                <th style="width:20%" class="tableCtnRight" v-if="arr_FV.ET==5">
                                    {{this.getLanguage['AFF']['TT']}}
                                    <span> {{this.getLanguage['TNMTESR']['SPRWL']}}</span></th>
                                <th style="width:20%" class="tableCtnRight" v-if="arr_FV.ET==5">{{this.getLanguage['TNMTESR']['TSSW']}}</th>
                            </tr>
                        </thead>
                        <tbody v-if="bool_showSummary">
                        <td colspan="100%" v-if="(arr_FV.ET==4|| arr_FV.ET==5) && (arry_Psl2.length == 0)">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-if="arr_FV.ET==4" v-for="(data,index) in arry_Psl2">
                            <td>{{ data.IC }} </td>
                            <td class="tableCtnRight">{{ formatNumber(data.TMC, 0) }}</td>
                            <td class="tableCtnRight">{{ formatNumber(data.TPC, 0) }}</td>
                            <td class='tableCtnRight'>
                                <span v-if="arr_FV.ET==4 && data.FS > 0" class="grid-line">
                                    {{ formatNumber(data.FS, 0) }}
                                </span>
                                <span v-else class="grid-line">-</span>
                            </td>
                            <td class='tableCtnRight'>
                                <!--Spin Winning-->
                                <span v-if="arr_FV.ET==4 && data.FSWA > 0" class="grid-line tableCtnRight">{{formatNumber(data.FSWA, 2,data.CS)}}</span>
                                <span v-else class="grid-line tableCtnRight">-</span>
                            </td>
                            <td :style="renderActivityStyle(3)" class="tableCtnRight"  v-if="arr_FV.ET==4">{{ formatNumber(data.TPA, 2, data.CS) }}</td>
                        </tr>
                        <tr v-if="arr_FV.ET==5" v-for="(data,index) in arry_Psl2">
                            <td></td>
                            <td>{{ data.IC }} </td>
                            <td :class="data.TSPRWL * -1 < 0? 'negative-number': 'positive-number'" class='tableCtnRight'>{{formatNumber(data.TSPRWL * -1, 2,data.CS)}}</td>
                            <td :style="renderActivityStyle(3)" class="tableCtnRight">{{ formatNumber(data.TAW, 2, data.CS) }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Prize Drop -->
            <div class='table-wrapper' v-if="arr_FV.ET==2">
                <header class="table-header">
                    <strong>{{this.getLanguage['MSA']['MRL']}}</strong>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TTY"] }}<i @click="setSortTable('CDT')" :class="setSortLogo('CDT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["F"] }}<i @click="setSortTable('TF')" :class="setSortLogo('TF')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["T"] }}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["TNMT"]["PA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TTY"] }}<i @click="setSortTable('CDT')" :class="setSortLogo('CDT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["F"] }}<i @click="setSortTable('TF')" :class="setSortLogo('TF')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["T"] }}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["TNMT"]["PA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_TournamentReportGroupByList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_TournamentReportGroupByList">
                            <tr v-for="(cdata, cindex) in arr_TournamentReportList" v-if="opened.includes(cdata.AGI) && cdata.AGI == data.AGI">
                                <td>{{ cdata.RN }}</td>
                                <td><span class="grid-line">{{ cdata.GN }} ({{ cdata.GPC }})</span></td>
                                <td>{{ renderAgentGroupName(cdata.OGN, cdata.OGPC) }}</td>
                                <td>
                                    <router-link :to="{ path: '/R/MSAR', query:{ agi: cdata.SAGI ? cdata.PGI : cdata.AGI, sagi: cdata.SAGI ? cdata.SAGI : 0, tn: cdata.TN, df: parseDateToJsonString(cdata.PTS), dt: parseDateToJsonString(setEndDate(cdata.PTS)) }}" target="_blank">
                                        <div class="custom_tooltip">
                                            <span v-if="cdata.TRC != ''">[{{ cdata.TRC }}] </span>
                                            <span>{{ cdata.TN }}</span>
                                            <span class="tooltiptext">{{ getLanguage['TNMT']['VR'] }}</span>
                                        </div>
                                    </router-link>
                                </td>
                                <td>{{ renderTournamentType(cdata.CDT) }}</td>
                                <td>{{ formatDate(cdata.TF, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                <td>{{ formatDate(cdata.TT, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                <td>{{ cdata.TPZISOC }}</td>
                                <td class="tableCtnRight">{{ formatNumber(cdata.PA, 2, cdata.TPZISOC, false) }}</td>
                                <td>{{ formatDateTime(cdata.PTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            </tr>
                            <tr class="reportTotal kema-eft" :class="opened.includes(data.AGI)?'reportTotal2':''" @click="toggleDisplay(data.AGI)" :style="{'cursor': 'pointer'} ">
                                <td></td>
                                <td><span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{{ data.TPZISOC }}</td>
                                <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.PA, 2, data.TPZISOC, false) }}</td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Daily Lucky Spin -->
            <div class='table-wrapper' v-else-if="arr_FV.ET==3">
                <header class="table-header">
                    <strong>{{this.getLanguage['SMB']['DLSRL']}}</strong>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_TournamentReportGroupByList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_TournamentReportGroupByList">
                            <tr v-for="(cdata, cindex) in arr_TournamentReportList" v-if="opened.includes(cdata.AGI) && cdata.AGI == data.AGI">
                                <td>{{ cdata.RN }}</td>
                                <td><span class="grid-line">{{ cdata.GN }} ({{ cdata.GPC }})</span></td>
                                <td>{{ renderAgentGroupName(cdata.OGN, cdata.OGPC) }}</td>
                                <td>
                                    <router-link :to="{ path: '/R/DLSR', query:{ agi: cdata.SAGI ? cdata.PGI : cdata.AGI, sagi: cdata.SAGI ? cdata.SAGI : 0, pn: cdata.TN, df: parseDateToJsonString(cdata.PTS), dt: parseDateToJsonString(setEndDate(cdata.PTS)) }}" target="_blank">
                                        <div class="custom_tooltip">
                                            <span v-if="cdata.TRC != ''">[{{ cdata.TRC }}] </span>
                                            <span>{{ cdata.TN }}</span>
                                            <span class="tooltiptext">{{ getLanguage['TNMT']['VR'] }}</span>
                                        </div>
                                    </router-link>
                                </td>
                                <td>{{ cdata.TPZISOC }}</td>
                                <td class="tableCtnRight">{{ formatNumber(cdata.PA, 2, cdata.TPZISOC, false) }}</td>
                                <td>{{ formatDateTime(cdata.PTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}</td>
                            </tr>
                            <tr class="reportTotal kema-eft" :class="opened.includes(data.AGI)?'reportTotal2':''" @click="toggleDisplay(data.AGI)" :style="{'cursor': 'pointer'} ">
                                <td></td>
                                <td><span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span></td>
                                <td></td>
                                <td></td>
                                <td>{{ data.TPZISOC }}</td>
                                <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.PA, 2, data.TPZISOC, false) }}</td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Promotion Free Spin -->
            <div class='table-wrapper' v-else-if="arr_FV.ET==4">
                <header class="table-header">
                    <strong>{{this.getLanguage['MEM']['PFSL']}}</strong>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["DLSP"]["SW"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_TournamentReportGroupByList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_TournamentReportGroupByList">
                            <tr v-for="(cdata, cindex) in arr_TournamentReportList" v-if="opened.includes(cdata.AGI) && cdata.AGI == data.AGI">
                                <td>{{ cdata.RN }}</td>
                                <td><span class="grid-line">{{ cdata.GN }} ({{ cdata.GPC }})</span></td>
                                <td>{{ renderAgentGroupName(cdata.OGN, cdata.OGPC) }}</td>
                                <td>
                                    <router-link :to="{ path: '/R/PR', query:{ agi: cdata.SAGI ? cdata.PGI : cdata.AGI, sagi: cdata.SAGI ? cdata.SAGI : 0, pc: cdata.TN, pf: parseDateToJsonString(cdata.TF), pt: parseDateToJsonString(cdata.TT), et: 4}}" target="_blank">
                                        <div class="custom_tooltip">
                                            <span v-if="cdata.TRC != ''">[{{ cdata.TRC }}] </span>
                                            <span>{{ cdata.TN }}</span>
                                            <span class="tooltiptext">{{ getLanguage['TNMT']['VR'] }}</span>
                                        </div>
                                    </router-link>
                                </td>
                                <td>{{ cdata.TPZISOC }}</td>
                                <td class="tableCtnRight">{{ formatNumber(cdata.PA, 2, cdata.TPZISOC, false) }}</td>
                                <td>{{ formatDateTime(cdata.PTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}</td>
                            </tr>
                            <tr class="reportTotal kema-eft" :class="opened.includes(data.AGI)?'reportTotal2':''" @click="toggleDisplay(data.AGI)" :style="{'cursor': 'pointer'} ">
                                <td></td>
                                <td><span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span></td>
                                <td></td>
                                <td></td>
                                <td>{{ data.TPZISOC }}</td>
                                <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.PA, 2, data.TPZISOC, false) }}</td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- One time special bonus -->
            <div class='table-wrapper' v-else-if="arr_FV.ET==5">
                <header class="table-header">
                    <strong>{{this.getLanguage['TNMTESR']['PBAL']}}</strong>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <!-- <th class="tableCtnRight">{{ this.getLanguage["TNMTESR"]["URWLA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th> -->
                                <th class="tableCtnRight">{{ this.getLanguage["TNMTESR"]["SPRWL"] }} {{ this.getLanguage["TNMTESR"]["SPRWL1"] }}<i @click="setSortTable('SPRWL')" :class="setSortLogo('SPRWL')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["TNMTESR"]["SSW"] }}<i @click="setSortTable('APA')" :class="setSortLogo('APA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <!-- <th class="tableCtnRight">{{ this.getLanguage["TNMTESR"]["URWLA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th> -->
                                <th class="tableCtnRight">{{ this.getLanguage["TNMTESR"]["SPRWL"] }} {{ this.getLanguage["TNMTESR"]["SPRWL1"] }}<i @click="setSortTable('SPRWL')" :class="setSortLogo('SPRWL')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["TNMTESR"]["SSW"] }}<i @click="setSortTable('APA')" :class="setSortLogo('APA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_TournamentReportGroupByList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_TournamentReportGroupByList">
                            <tr v-for="(cdata, cindex) in arr_TournamentReportList" v-if="opened.includes(cdata.AGI) && cdata.AGI == data.AGI">
                                <td>{{ cdata.RN }}</td>
                                <td><span class="grid-line">{{ cdata.GN }} ({{ cdata.GPC }})</span></td>
                                <td>{{ renderAgentGroupName(cdata.OGN, cdata.OGPC) }}</td>
                                <td>
                                    <router-link :to="{ path: '/R/PR', query:{ agi: cdata.SAGI ? cdata.PGI : cdata.AGI, sagi: cdata.SAGI ? cdata.SAGI : 0, pc: cdata.TN, et: 5, pf: parseDateToJsonString(cdata.TF), pt: parseDateToJsonString(cdata.TT) }}" target="_blank">
                                        <div class="custom_tooltip">
                                            <span v-if="cdata.TRC != ''">[{{ cdata.TRC }}] </span>
                                            <span>{{ cdata.TN }}</span>
                                            <span class="tooltiptext">{{ getLanguage['TNMT']['VR'] }}</span>
                                        </div>
                                    </router-link>
                                </td>
                                <td>{{ cdata.TPZISOC }}</td>
                                <!-- <td :class="cdata.PA < 0? 'negative-number': 'positive-number'" class="tableCtnRight">{{ formatNumber(cdata.PA, 2, cdata.TPZISOC, false) }}</td> -->
                                <td :class="cdata.SPRWL * -1 < 0? 'negative-number': 'positive-number'" class="tableCtnRight">{{ formatNumber(cdata.SPRWL * -1, 2, cdata.TPZISOC, false) }}</td>
                                <td class="positive-number tableCtnRight">{{ formatNumber(cdata.APA, 2, cdata.TPZISOC, false) }}</td>
                                <td>{{ formatDateTime(cdata.PTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}</td>
                            </tr>
                            <tr class="reportTotal kema-eft" :class="opened.includes(data.AGI)?'reportTotal2':''" @click="toggleDisplay(data.AGI)" :style="{'cursor': 'pointer'} ">
                                <td></td>
                                <td><span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span></td>
                                <td></td>
                                <td></td>
                                <td>{{ data.TPZISOC }}</td>
                                <!-- <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.PA, 2, data.TPZISOC, false) }}</td> -->
                                <td :class="data.SPRWL * -1 < 0? 'negative-number': 'positive-number'" class="tableCtnRight">{{ formatNumber(data.SPRWL * -1, 2, data.TPZISOC, false) }}</td>
                                <td class="positive-number tableCtnRight">{{ formatNumber(data.APA, 2, data.TPZISOC, false) }}</td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
            <!-- Tournament -->
            <div class='table-wrapper' v-else>
                <header class="table-header">
                    <strong>{{this.getLanguage['TNMT']['TNMTRL']}}</strong>
                    <div class="pageBtn">
                        <div>
                            <CButton v-if="checkModuleAccess2(constAccessType.edit)" class="btnExcel" @click="saveToExcel()">
                                <img src="/Content/img/excel.png" width="20" style="padding-left:2px">
                                {{this.getLanguage["BTN"]["DL"]}}
                            </CButton>
                        </div>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TTY"] }}<i @click="setSortTable('CDT')" :class="setSortLogo('CDT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["F"] }}<i @click="setSortTable('TF')" :class="setSortLogo('TF')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["T"] }}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["TNMT"]["PA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{ this.getLanguage["GL"]["NO"] }}</th>
                                <th>{{this.getLanguage["GL"]["AGT"]}}<i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["ORGN"] }}<i @click="setSortTable('OGN')" :class="setSortLogo('OGN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TN"] }}<i @click="setSortTable('TN')" :class="setSortLogo('TN')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TTY"] }}<i @click="setSortTable('CDT')" :class="setSortLogo('CDT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["F"] }}<i @click="setSortTable('TF')" :class="setSortLogo('TF')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["N"]["T"] }}<i @click="setSortTable('TT')" :class="setSortLogo('TT')" class="sortlogo"></i></th>
                                <th>{{ this.getLanguage["TNMT"]["TPC"] }}<i @click="setSortTable('ISOC')" :class="setSortLogo('ISOC')" class="sortlogo"></i></th>
                                <th class="tableCtnRight">{{ this.getLanguage["TNMT"]["PA"] }}<i @click="setSortTable('PA')" :class="setSortLogo('PA')" class="sortlogo"></i></th>
                                <th>{{this.getLanguage['TNMT']['PYT']}}<i @click="setSortTable('PTS')" :class="setSortLogo('PTS')" class="sortlogo"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_TournamentReportGroupByList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <template v-for="(data,index) in arr_TournamentReportGroupByList">
                            <tr v-for="(cdata, cindex) in arr_TournamentReportList" v-if="opened.includes(cdata.AGI) && cdata.AGI == data.AGI">
                                <td>{{ cdata.RN }}</td>
                                <td><span class="grid-line">{{ cdata.GN }} ({{ cdata.GPC }})</span></td>
                                <td>{{ renderAgentGroupName(cdata.OGN, cdata.OGPC) }}</td>
                                <td>
                                    <router-link :to="{ path: '/R/TNMTR', query:{ agi: cdata.SAGI ? cdata.PGI : cdata.AGI, sagi: cdata.SAGI ? cdata.SAGI : 0, tn: cdata.TN, df: parseDateToJsonString(cdata.PTS), dt: parseDateToJsonString(setEndDate(cdata.PTS)) }}" target="_blank">
                                        <div class="custom_tooltip">
                                            <span v-if="cdata.TRC != ''">[{{ cdata.TRC }}] </span>
                                            <span>{{ cdata.TN }}</span>
                                            <span class="tooltiptext">{{ getLanguage['TNMT']['VR'] }}</span>
                                        </div>
                                    </router-link>
                                </td>
                                <td>{{ renderTournamentType(cdata.CDT) }}</td>
                                <td>{{ formatDate(cdata.TF, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                <td>{{ formatDate(cdata.TT, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                <td>{{ cdata.TPZISOC }}</td>
                                <td class="tableCtnRight">{{ formatNumber(cdata.PA, 2, cdata.TPZISOC, false) }}</td>
                                <td>{{ formatDateTime(cdata.PTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            </tr>
                            <tr class="reportTotal kema-eft" :class="opened.includes(data.AGI)?'reportTotal2':''" @click="toggleDisplay(data.AGI)" :style="{'cursor': 'pointer'} ">
                                <td></td>
                                <td><span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td>{{ data.TPZISOC }}</td>
                                <td :style="renderActivityStyle(1)" class="tableCtnRight">{{ formatNumber(data.PA, 2, data.TPZISOC, false) }}</td>
                                <td></td>
                            </tr>
                        </template>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { constAccessType, loadingFullScreen, constTournamentType } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker';
    import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
    import Treeselect from '@riophae/vue-treeselect';
    import { customtreeselect } from '@/views/CustomControl/index.js';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { mapGetters } from 'vuex';
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import Vue from 'vue'
    import $ from 'jquery'

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
        },
        data() {
            return {
                str_tableSortBy: "AGI", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSummary: true,
                bool_showSearchBar: true,
                arr_FV: {
                    "MI": null,
                    "PTS": {
                        startDate: this.getMonthStartDate(),
                        endDate: this.getMonthEndDate()
                    },
                    "TN": "",
                    "AGI": null,
                    "AGI_csv": null,
                    "SAGAGI": null,
                    "CI": null,
                    "CTCI": null,
                    "CDT": null,
                    "ET": 1,
                    "GPI": null,
                    "ISS": null,
                    "OBAGI": null
                },
                arr_TournamentReportList: [],
                arr_TournamentReportGroupByList: [],
                dd_memberdlsstatus: [],
                dd_agentgroup: [],
                dd_subagentgroup: [],
                ddDefaultSubBrand: [],
                dd_TournamentPayoutOption: [],
                rtSubBrand: 0,
                ddMemberList: [],
                dd_currency: [],
                arry_Psl: [],
                arry_Psl2: [],
                constAccessType: constAccessType,
                hideBrand: false,
                disableSubDD: false,
                IsGroupBySubAgent: false,
                opened: [],
                bool_firstLogin: false,
                dd_currencyfilter: null,
                dd_event_type: [],
                dd_sponsor: [],
                dd_gameProvider: [],
                ddGameProviderList: [],
                decimal_gt: 0,
                currencySymbol_gt: "",
                searchGameProviderId: [],
                ddOrganizerList: null,
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'checkModuleIndex']),
        },
        methods: {
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.PTS.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_FV.PTS.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_FV.PTS.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_FV.PTS.endDate = "";
                    }
                }
                this.OganizerChange();
            },           
            newSearch() {
                this.$refs.search.focus();
                this.getTournamentReportList();
            },
            toggleDisplay(key) {
                //this.opened = [];
                const index = this.opened.indexOf(key);
                if (index > -1) {
                    this.opened.splice(index, 1)
                } else {
                    this.opened.push(key)
                }
                this.resizeTableHead();
            },
            getdd() {
                this.dd_event_type = [
                    { id: 1, label: this.getLanguage["TNMT"]["TNMT"] },
                    { id: 2, label: this.getLanguage["SMB"]["MSA"] },
                    { id: 3, label: this.getLanguage["MEM"]["REWARD"] },
                    { id: 4, label: this.getLanguage["MEM"]["PFS"] },
                    { id: 5, label: this.getLanguage["TNMTSR"]["PBA"] }
                ];

                this.dd_sponsor = [
                    { id: 0, label: this.getLanguage["EVTSTL"]["ISNS"] },
                    { id: 1, label: this.getLanguage["EVTSTL"]["ISS"] }
                ];

                this.dd_TournamentPayoutOption = [{
                    id: 1,
                    label: this.getLanguage["PM"]["DLY"]
                }, {
                    id: 2,
                    label: this.getLanguage["PM"]["WLY"]
                }, {
                    id: 3,
                    label: this.getLanguage["PM"]["MLY"]
                }];
            },
            getDropdownList() {
                var that = this;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);
                        }
                    });


                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });

                 this.getDataApi(`/api/dd/game/frbprovbycategory/0/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var i = 0; i < d.dropdownlist.length; i++) {
                                d.dropdownlist[i].label = that.renderProviderName(d.dropdownlist[i].label);
                            }
                            that.dd_gameProvider = d.dropdownlist;
                        }
                    });
                
                this.getDataApi('/api/dd/game/prov/0/1/1',
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            for (var j = 0; j < d.dropdownlist.length; j++) {
                                d.dropdownlist[j].label = that.renderCategory(d.dropdownlist[j].id.slice(d.dropdownlist[j].id.indexOf('-') + 1));
                                if (d.dropdownlist[j].children != null && d.dropdownlist[j].children.length > 0) {
                                    for (var l = 0; l < d.dropdownlist[j].children.length; l++) {
                                        if (d.dropdownlist[j].children[l].label in that.getLanguage['GP'])
                                            d.dropdownlist[j].children[l].label = that.renderProviderName(d.dropdownlist[j].children[l].label);
                                    }

                                }
                            }

                            that.ddGameProviderList = that.appendSelectAllOption(d.dropdownlist);
                        }
                    });
            },
            renderCategory(id) {
                return this.getLanguage["GC"][id];
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.arr_FV["AGI_csv"]) {
                    parentAGI = this.arr_FV["AGI_csv"];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else if (this.getUserInfo.AT != 3) {
                    this.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                    return;
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.arr_FV['SAGAGI'] = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getTournamentReportList();
                    });
            },
            EventTypeChange(){
                this.arr_TournamentReportGroupByList = [];
                this.arr_TournamentReportList = [];
                this.OganizerChange();
            },
            AgentGroupChangefs(value) {
                this.disableSubDD = false;
                this.IsGroupBySubAgent = false;
                this.arr_FV["AGI_csv"] = null;
                this.arr_FV["SAGAGI"] = null;
                if (value != undefined) {
                    if (value != "") {
                        var temp = "";
                        for (var x = 0; x < value.length; x++) {
                            if (x != 0) {
                                temp += ",";
                            }
                            var split = value[x].split("-");

                            if (split.length == 2) {
                                temp += split[1];
                            }
                            else {
                                temp += split[0];
                            }
                        }
                        this.arr_FV["AGI_csv"] = temp;
                        this.searchPAgi = this.arr_FV["AGI_csv"];
                        this.arr_FV["SAGAGI"] = null;
                        if (value.length > 1) {
                            this.disableSubDD = true;
                        }
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.arr_FV['AGI_csv'] = null;
                }
                this.arr_FV['CI'] = null;
                this.dd_currencyfilter = null;
                this.getCurrencyList();
                this.OganizerChange();
            },
            SubAgentGroupChangefs(value) {
                if (value != undefined) {
                    var agi = 0;
                    if (value != "") {
                        agi = value;
                        this.arr_FV["SAGAGI"] = agi;
                    }
                }
                else {
                    this.arr_FV['SAGAGI'] = null;
                }
                this.OganizerChange();
            },
            getTournamentReportList() {
                this.bool_fullLoading = true;
                this.opened = [];
                var that = this;
                //var path = "";
                var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);

                if (this.arr_FV) {

                    var encodedSearchEventName = "";
                    if(this.arr_FV["TN"] != null){
                        encodedSearchEventName = encodeURIComponent(this.arr_FV["TN"].replace(/\[/g, '[[').replace(/\]/g, ']]'));
                    }
                    
                    path += (
                        "&f.MI=" + (this.arr_FV["MI"] == null ? "" : this.arr_FV["MI"]) +
                        "&f.TN=" + (encodedSearchEventName) +
                        "&f.ET=" + (this.arr_FV["ET"] == null ? 1 : this.arr_FV["ET"]) +
                        "&f.CDT=" + (this.arr_FV["CDT"] == null ? "" : this.arr_FV["CDT"]) +
                        "&f.ISS=" + (this.arr_FV["ISS"] == null ? "" : this.arr_FV["ISS"])
                    );

                    if (this.arr_FV.PTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.PTS.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.PTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.PTS.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }
                   
                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.SAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                    if (this.arr_FV["CI"] != null) {
                        path += "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);
                        path += "&f.CI_csv=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);

                    }
                    if (this.arr_FV["GPI"] != null) {
                        path += "&f.GPI=" + (this.arr_FV["GPI"] == null ? "" : this.arr_FV["GPI"]);
                    }

                    if (this.arr_FV["CTCI"] != null) {
                        path += "&f.CTCI=" + this.arr_FV["CTCI"];
                    }
                    else if (localStorage.getItem('CCUSD') != "") {
                        path += "&f.CTCI=" + localStorage.getItem('CCUSD');

                    }
                    if (this.searchGameProviderId) {
                        path += "&f.GPI_in=" + this.searchGameProviderId;
                    }
                    if (this.IsGroupBySubAgent == true) {
                        path += "&f.IGBSA=1";
                    }
                    path += "&f.OBAGI=" + (this.arr_FV["OBAGI"] ? this.arr_FV["OBAGI"] : 0);
                }

                this.getDataApi(`/api/tournament/lrgb?${path}&f[IGBA]=1&f[FESR]=1`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {

                            if (d.R1 == null) {
                                that.arr_TournamentReportGroupByList = [];
                            } else {
                                that.arr_TournamentReportGroupByList = d.R1;
                            }
                            if (d.R2 == null) {
                                that.arr_TournamentReportList = [];
                            } else {
                                that.arr_TournamentReportList = d.R2;                                
                            }
                            that.resizeTableHead();
                            that.setTournamentSummaryList(that.arr_TournamentReportGroupByList);
                        }
                    });

                if (this.arr_FV.ET === 4 || this.arr_FV.ET === 5) {
                    this.getDataApi(`/api/tournament/lr/total2?${path}`, (data) => {
                        that.setPromotionSummaryList(data);
                    });
                }
            },
            setTournamentSummaryList(data) {
                this.arry_Psl = [];
                this.decimal_gt = 0;
                this.currencySymbol_gt = "";
                if (data != null) {
                    this.arry_Psl = data;
                    if (this.arry_Psl.length != 0) {
                        for (var i = 0; i < this.arry_Psl.length; i++) {
                            if(i == 0){
                                this.currencySymbol_gt = this.arry_Psl[i].TPZISOC;
                            }
                            this.decimal_gt += this.arry_Psl[i].PA;
                        }
                    }
                }
            }, 
            setPromotionSummaryList(data) {
                this.arry_Psl2 = [];
                if (data != null) {
                    this.arry_Psl2 = data;
                }
            },
            renderTournamentType(type) {
                for (var i = 0; i < constTournamentType.length; i++) {
                    if (constTournamentType[i].id == type)
                        return constTournamentType[i].label;
                }
                return "-";
            },
            clearDateRangeFilter() {
                this.arr_FV.PTS = {
                    startDate: this.getTodayDate(),
                    endDate: this.getMonthEndDate()
                };
                this.OganizerChange();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('EPE', 'R', type);
            },
            saveToExcel() {
                var path = this.getListingParamQuery(null, null, this.str_tableSortBy, this.bool_isSort);
                if (this.arr_FV) {

                    var encodedSearchEventName = "";
                    if(this.arr_FV["TN"] != null){
                        encodedSearchEventName = encodeURIComponent(this.arr_FV["TN"]);
                    }

                    path += (
                        "&f.IGBA=1" + 
                        "&f.MI=" + (this.arr_FV["MI"] == null ? "" : this.arr_FV["MI"]) +
                        "&f.TN=" + (encodedSearchEventName) +
                        "&f.ET=" + (this.arr_FV["ET"] == null ? 1 : this.arr_FV["ET"]) +
                        "&f.CDT=" + (this.arr_FV["CDT"] == null ? "" : this.arr_FV["CDT"])
                    );

                    if (this.arr_FV.PTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.PTS.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.PTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.PTS.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.SAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                    if (this.arr_FV["CI"] != null) {
                        path += "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);
                    }
                    if (this.arr_FV["CTCI"] != null) {
                        path += "&f.CTCI=" + this.arr_FV["CTCI"];
                    }
                    else if (localStorage.getItem('CCUSD') != "") {
                        path += "&f.CTCI=" + localStorage.getItem('CCUSD');

                    }
                    if (this.IsGroupBySubAgent == true) {
                        path += "&f.IGBSA=1";
                    }
                    path += "&f.OBAGI=" + (this.arr_FV["OBAGI"] ? this.arr_FV["OBAGI"] : 0);
                }
                window.open('/api/tournament/tournamentexcel?' + path, '_blank');

            },
            renderActivityStyle(Activitytype) {
                if (Activitytype == 1) {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
                else if (Activitytype == 2) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else if (Activitytype == 3) {
                    return { 'font-weight': 'bold', color: '#7800b6' };
                }

            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },

            updateCC() {
                if (this.arr_FV["CTCI"] == null) {
                    localStorage.setItem('CCUSD', "");
                }
                else {
                    localStorage.setItem('CCUSD', this.arr_FV["CTCI"]);
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currencyfilter = d.dropdownlist;
                        }
                    });
            },
            loadCurrencyOptions() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.dd_currency = d.dropdownlist;
                            if (that.dd_currency.length > 0) {
                                if (localStorage.getItem('CCUSD') != "") {
                                    for (var i = 0; i < that.dd_currency.length; i++) {
                                        if (that.dd_currency[i].id == localStorage.getItem('CCUSD')) {
                                            that.arr_FV['CTCI'] = that.dd_currency[i].id;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            that.dd_currency = null;
                        }

                    });
            },
            setSortTable(SV) {
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getTournamentReportList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            loadOrganizerOptions({ action, callback, instanceId }) {
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                if (this.arr_FV) {
                    var encodedSearchEventName = "";
                    if (this.arr_FV["TN"] != null) {
                        encodedSearchEventName = encodeURIComponent(this.arr_FV["TN"].replace(/\[/g, '[[').replace(/\]/g, ']]'));
                    }

                    path += (
                        "&f.IGBA=1" + 
                        "&f.TN=" + (encodedSearchEventName) +
                        "&f.ET=" + (this.arr_FV["ET"] == null ? 1 : this.arr_FV["ET"]) +
                        "&f.CDT=" + (this.arr_FV["CDT"] == null ? "" : this.arr_FV["CDT"])
                    );

                    if (this.arr_FV.PTS.startDate != "") {
                        var cts_from = this.parseDateToJsonString(this.arr_FV.PTS.startDate);
                        path += "&f.PTS_from=" + cts_from;
                    }
                    if (this.arr_FV.PTS.endDate != "") {
                        var cts_to = this.parseDateToJsonString(this.arr_FV.PTS.endDate);
                        path += "&f.PTS_to=" + cts_to;
                    }

                    if (this.arr_FV["SAGAGI"]) {
                        path += "&f.SAGI=" + (this.arr_FV["SAGAGI"] == null ? "" : this.arr_FV["SAGAGI"])
                    }
                    if (this.arr_FV["AGI_csv"]) {
                        path += "&f.AGI_csv=" + (this.arr_FV["AGI_csv"] == null ? "" : this.arr_FV["AGI_csv"]);
                    }
                    if (this.arr_FV["CI"] != null) {
                        path += "&f.CI=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);
                        path += "&f.CI_csv=" + (this.arr_FV["CI"] == null ? "" : this.arr_FV["CI"]);

                    }
                    //if (this.arr_FV["GPI"] != null) {
                    //    path += "&f.GPI=" + (this.arr_FV["GPI"] == null ? "" : this.arr_FV["GPI"]);
                    //}

                    //if (this.arr_FV["CTCI"] != null) {
                    //    path += "&f.CTCI=" + this.arr_FV["CTCI"];
                    //}
                    //else if (localStorage.getItem('CCUSD') != "") {
                    //    path += "&f.CTCI=" + localStorage.getItem('CCUSD');

                    //}
                    //if (this.searchGameProviderId) {
                    //    path += "&f.GPI_in=" + this.searchGameProviderId;
                    //}
                    if (this.IsGroupBySubAgent == true) {
                        path += "&f.IGBSA=1";
                    }
                }
                
                this.getDataApi(`/api/tournament/organizer-ev?${path}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddOrganizerList = d.dropdownlist;
                        }
                        else {
                            that.ddOrganizerList = null;
                        }
                        callback(null, that.ddOrganizerList);
                    });
            },
            OganizerChange() {
                this.ddOrganizerList = null;
            },
            defaultDateRangePickerUpdateEvent(dt) {
                if (dt) {
                    if (dt.startDate) {
                        dt.startDate.setHours(0, 0, 0, 0);
                    }

                    if (dt.endDate) {
                        dt.endDate.setHours(23, 59, 59, 59, 997);
                    }
                }
                this.OganizerChange();
            },
        },

        created() {
            this.$parent.showSubMenu = 'R';
            this.$parent.showActiveMenu = 'R.TNMTSR';
            if (this.checkModuleIndex('TNMTSR', 'R', constAccessType.view, '', -1) == '7.4.7') {
                this.$parent.showSubSubMenu = 'RS4';
            } else if (this.checkModuleIndex('TNMTSR', 'R', constAccessType.view, '', -1) == '7.5.1') {
                this.$parent.showSubSubMenu = 'RS5';
            }
            this.loadCurrencyOptions();
            this.hideBrand = this.getUserInfo.IHAGIF;
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
            this.arr_FV.AGI = this.$route.query.agi;
            this.arr_FV.SAGAGI = this.$route.query.sagi;
            this.arr_FV.TN = this.$route.query.tn;

            if (this.$route.query.ci) {
                this.arr_FV.CI = [];
                this.arr_FV.CI.push(this.$route.query.ci);
            }
            if (this.$route.query.cur) {
                this.arr_FV["CTCI"] = this.$route.query.cur;
                sessionStorage.setItem('FilterCur', this.$route.query.cur);
            } else {
                var FilterCur = sessionStorage.getItem('FilterCur');
                if (FilterCur) {
                    this.arr_FV["CTCI"] = FilterCur;
                    sessionStorage.removeItem('FilterCur');
                }
            }
            if (this.$route.query.df) {
                this.arr_FV.PTS.startDate = this.$route.query.df;
            }
            if (this.$route.query.dt) {
                this.arr_FV.PTS.endDate = this.$route.query.dt;
            }

            this.getDropdownList();
            this.getCurrencyList();
            this.getdd();
            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);
            else
                this.getTournamentReportList();

        },
        watch: {
            getLanguage() {
                this.getTournamentReportList();
                this.getdd();
            },
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/SideMenu/Reports/TournamentSettlementReport.vue